// Tick — deterministic fixed-timestep simulation

import { World, System } from "./ecs.js";
import type { PlayerInput } from "./input.js";
import { touchEvents } from "./events.js";

export const TICK_RATE = 60;
export const TICK_MS = 1000 / TICK_RATE;

export type SimContext = {
  inputs: Map<number, PlayerInput>;
};

export let simContext: SimContext = {
  inputs: new Map(),
};

export function simulate(
  world: World,
  systems: System[],
  inputs: Map<number, PlayerInput>
): void {
  touchEvents.clear();
  simContext = { inputs };
  world.tick++;
  for (const system of systems) {
    system();
  }
}
